import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';
import { withSdk } from 'pkg/core/with_sdk';

import type {
	LineupPayload,
	LineupPositionPayload,
} from 'routes/lineup/provider';

interface ActionCallbacks {
	onSuccess: () => void;
	onFailure?: () => void;
}

export async function update(
	organizationID: number,
	payload: LineupPayload,
	callbacks?: ActionCallbacks
) {
	const request = await sdk.get(
		endpoints.Lineups.Show(organizationID, payload.id)
	);

	if (!request.ok) {
		callbacks?.onFailure?.();

		return;
	}

	const lineup = (await request.json()) as models.lineup.LineupTemplate;

	if (!lineup) {
		callbacks?.onFailure?.();

		return;
	}

	const positions: LineupPositionPayload[] = [];

	lineup.positions?.forEach((lineupPosition, row) => {
		lineupPosition.forEach((position, rowPosition) => {
			if (position.userId) {
				positions.push({
					userId: position.userId,
					row,
					rowPosition,
					position: position.label,
				});
			}
		});
	});

	payload.positions = positions;

	return withSdk(
		'patch',
		endpoints.Lineups.Update(organizationID, payload.id),
		callbacks
	)(payload);
}

export async function remove(
	organizationID: number,
	lineupID: number,
	callbacks?: ActionCallbacks
) {
	return withSdk(
		'delete',
		endpoints.Lineups.Show(organizationID, lineupID),
		callbacks
	)();
}
